import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Collection } from 'src/components/common/cards/types/types';
import IconSvg, { Icons } from 'src/components/common/ui/IconSvg';
import { useHttp } from 'src/hooks';
import MintCard from './components/MintCard';
import MintTableRow from './components/MintTableRow';
import BlurTableRow from './components/BlurTableRow';
import {ethers} from "ethers";
import {useAccount} from "wagmi";

function Mint() {
  const [collections, setCollections] = useState<Collection[]>([]);
  const { sendRequest } = useHttp();
  const navigate = useNavigate();
  const [arenaTotalMintedKeys, setArenaTotalMintedKeys] = useState('');
  const [activeTab, setActiveTab] = useState(() => localStorage.getItem('activeTab') || 'all');

  const [activeView, setActiveView] = useState('list');

  const tabs: { value: string; label: string; icon: Icons }[] = [
    { value: 'all', label: 'All projects', icon: 'allS' },
    {
      value: 'live',
      label: 'Live',
      icon: 'rectangleS',
    },
    {
      value: 'soon',
      label: 'Soon',
      icon: 'soonS',
    },
    {
      value: 'expired',
      label: 'Expired',
      icon: 'calendarS',
    },
  ];

  useEffect(() => {
    // Save the selected tab and view in localStorage whenever they change
    localStorage.setItem('activeTab', activeTab);
  }, [activeTab]);

  useEffect(() => {
    getCollections();
  }, [activeTab]);

  const getCollections = () => {
    sendRequest(
      {
        url: 'collections',
        method: 'GET',
      },
      (data: any) => {
        // const sortedCollections = data.sort((a: any, b: any) => {
        //   const stageA = a.stages[0] || {};
        //   const stageB = b.stages[0] || {};

        //   if (stageA.isLive && !stageB.isLive) return -1;
        //   if (!stageA.isLive && stageB.isLive) return 1;

        //   if (stageA.isSoon && !stageB.isSoon) return -1;
        //   if (!stageA.isSoon && stageB.isSoon) return 1;

        //   if (stageA.isExpired && !stageB.isExpired) return 1;
        //   if (!stageA.isExpired && stageB.isExpired) return -1;

        //   return 0;
        // });
        setCollections(data);
        // if (activeTab === 'expired') {
        //   const expiredProjects = data.filter((collection: any) => {
        //     return collection.stages && collection.stages[0]?.isExpired === true;
        //   });
        //   setCollections(expiredProjects);
        // } else {
        //   setCollections(sortedCollections);
        // }
      },
    );
  };

  const {address, isConnected} = useAccount();
  const environment = process.env.REACT_APP_ENVIRONMENT;
  const readMintedKeyEvents = async () => {
    try {
      const arenaCollection = collections.filter(collection => collection.slug == 'arena')[0];
      const phase1Config = arenaCollection?.stages?.filter(stage => stage.order === 1)[0]?.metadata[environment]; // right now just for arena
      if (!phase1Config) return;

      const provider = new ethers.providers.JsonRpcProvider(arenaCollection?.network.RPCUrl);
      const contract1 = new ethers.Contract(phase1Config.LOOTY_KEY.address, phase1Config.LOOTY_KEY.abi, provider);
      const eventFilter = contract1.filters.TransferSingle(null, "0x0000000000000000000000000000000000000000");
      const fromBlock = 1;
      const toBlock = 'latest';

      const events = await contract1.queryFilter(eventFilter, fromBlock, toBlock);

      console.log('eeeeeee', events)
      const mintedKeys = events.reduce((sum, event) => {
        const ev: any = event;
        return sum + ev?.args?.value.toNumber();
      }, 0);
      console.log('readMintedKeyEvents-> Total Minted Keys:', mintedKeys);
      setArenaTotalMintedKeys(mintedKeys);
    } catch (error) {
      console.error("Error initializing event listener:", error);
    }
  };
  useEffect(() => {
    if(address && isConnected && collections?.length > 0)
      readMintedKeyEvents();

  }, [address, isConnected, collections])

  const handleClick = (collection: Collection, buttonType: 'mint' | 'openbox' | 'checkReward') => {
    switch (buttonType) {
      case 'openbox':
        // navigate(`/openbox/${collection?.name.toLowerCase().replace(/\s+/g, '-')}`, {
        //   state: { id: collection?.id },
        // });
        navigate(`/avax/openbox/${collection?.id}`);
        break;
      case 'mint':
        navigate(`/mint/${collection?.name.toLowerCase().replace(/\s+/g, '-')}`, {
          state: { id: collection?.id },
        });
        break;
      case 'checkReward':
        navigate(`/mint/${collection?.name.toLowerCase().replace(/\s+/g, '-')}`, {
          state: { id: collection?.id },
        });
        break;
      default:
        console.warn('Unhandled button type:', buttonType);
        break;
    }
  };

  const filteredCollections = collections.filter(collection => {
    if (activeTab === 'all') return true; // Show all projects
    if (activeTab === 'live') return collection.status === 'Live';
    if (activeTab === 'soon') return collection.status === 'Soon';
    if (activeTab === 'expired') return collection.status === 'Expired';
    return false;
  });
  // if (searchQuery)
  //   filteredCollectionsEarn = filteredCollectionsEarn.filter(
  //     collection =>
  //       collection.name.toLowerCase().includes(searchQuery.toLowerCase()) &&
  //       !collection.isEarnBlured,
  //   );

  return (
    <>
      <section className="mb-[51px]">
        <div className="flex items-end justify-between">
          <div>
            <h2 className="uppercase mb-[19px] text-brand-primary-light">
              <span className="text-brand-primary">mint keys</span> to open box
            </h2>

            <p className="text-[#D7CCE0] max-w-[1032px] text-sm">
              Our top rewards celebrate exceptional achievements, offering unique digital
              collectibles and unforgettable real-life experiences. Browse through the latest
              claimed rewards. Join our community of winners and claim your hot rewards!
            </p>
          </div>

          <div className="flex gap-6">
            <div>
              <div className="mb-2 text-sm text-grayscale-400 text-end">Total value of rewards</div>
              <div className="text-lg font-semibold text-grayscale-100 text-end">≈ $370,000</div>
            </div>

            {/* <div className="border-l-2 h-[59px] border-grayscale-700"></div>

            <div>
              <div className="mb-2 text-sm text-grayscale-400 text-end">Total minted keys</div>
              <div className="text-lg font-semibold text-grayscale-100 text-end">1,991</div>
            </div>

            <div className="border-l-2 h-[59px] border-grayscale-700"></div>

            <div>
              <div className="mb-2 text-sm text-grayscale-400 text-end">Total reward won</div>
              <div className="text-lg font-semibold text-grayscale-100 text-end">445</div>
            </div> */}
          </div>
        </div>
      </section>

      <section className="mb-10">
        <div className="flex justify-between px-5 py-3 mb-10 rounded-md bg-grayscale-800">
          <div className="flex gap-2">
            {tabs.map(tab => (
              <div
                key={tab.value}
                onClick={() => setActiveTab(tab.value)}
                className={`px-4 py-2 rounded flex items-center gap-2 cursor-pointer ${
                  activeTab === tab.value ? 'bg-grayscale-600' : ''
                }`}
              >
                <IconSvg
                  icon={tab.icon}
                  className={activeTab === tab.value ? 'text-grayscale-200' : 'text-gray-300'}
                />

                <div
                  className={`text-sm font-semibold ${
                    activeTab === tab.value ? 'text-grayscale-200' : 'text-gray-300'
                  }`}
                >
                  {tab.label}
                </div>
              </div>
            ))}
          </div>

          {/* <div className="flex gap-2">
            <div
              onClick={() => setActiveView('grid')}
              className={`flex items-center justify-center w-10 h-10 rounded-md cursor-pointer ${
                activeView === 'grid' ? 'bg-brand-secondary text-grayscale-800' : 'bg-gray-700'
              }`}
            >
              <IconSvg
                icon="gridM"
                className={activeView === 'grid' ? 'text-grayscale-800' : 'text-grayscale-200'}
              />
            </div>

            <div
              onClick={() => setActiveView('list')}
              className={`flex items-center justify-center w-10 h-10 rounded-md cursor-pointer ${
                activeView === 'list' ? 'bg-brand-secondary text-grayscale-800' : 'bg-gray-700'
              }`}
            >
              <IconSvg
                icon="listM"
                className={activeView === 'list' ? 'text-grayscale-800' : 'text-grayscale-200'}
              />
            </div>
          </div> */}
        </div>
      </section>

      {activeView === 'list' ? (
        filteredCollections?.length === 0 ? (
          <div className="px-5 py-[15px] rounded-md items-center bg-grayscale-800 h-[90px] flex">
            <h5 className="text-brand-primary-light">No projects found</h5>
          </div>
        ) : (
          <div className="flex flex-col">
            <div className="overflow-x-auto scrollbar-dark">
              <div className="grid mb-5 grid-cols-15">
                <div className="col-span-3 pl-5 text-xs 2xl:text-sm text-grayscale-300 ">
                  Project
                </div>
                <div className="col-span-3 text-xs text-center 2xl:text-sm text-grayscale-300">
                  Total Reward Value
                </div>
                <div className="col-span-2 text-xs 2xl:text-sm text-grayscale-300 text-start">
                  Network Name
                </div>
                <div className="col-span-3 text-xs 2xl:text-sm text-grayscale-300">Keys Minted</div>
                <div className="col-span-2 text-xs 2xl:text-sm text-grayscale-300">Status</div>
                <div className="col-span-2"></div>
              </div>

              {[...filteredCollections]
                ?.filter(collection => !collection.isEarnBlured)
                .map((collection: Collection, index: number) => (
                  <MintTableRow arenaTotalMintedKeys={arenaTotalMintedKeys} key={index} collection={collection} handleClick={handleClick} />
                ))}

              {[...filteredCollections]
                ?.filter(collection => collection.isEarnBlured)
                .slice(0, 2)
                .map((_, index: number) => (
                  <BlurTableRow key={index} blurIndex={index + 1} />
                ))}
            </div>
          </div>
        )
      ) : (
        <div className="grid gap-[18px] grid-cols-[repeat(auto-fit,minmax(412px,1fr))]">
          {filteredCollections
            ?.filter(collection => !collection.isEarnBlured)
            .map((collection: Collection, index: number) => (
              <MintCard key={index} collection={collection} handleClick={handleClick} />
            ))}

          {filteredCollections
            ?.filter(collection => collection.isEarnBlured)
            .map((collection: Collection, index: number) => (
              <MintCard key={index} collection={collection} handleClick={handleClick} />
            ))}
        </div>
      )}
    </>
  );
}

export default Mint;
